import React from "react";
import FeatureSection from "../../components/FeatureSection";

function RestaurantFeatures() {
  return (
    <div>
      <FeatureSection
        title="Reward your team for generating more reviews"
        description="Motivate your team to proactively seek customer reviews by launching a well-structured incentive program. Boost participation by recognizing and rewarding top performers, fostering engagement and strengthening your brand’s reputation."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fa4a9ea13db063ff3f2cd3_Group%201000005193%20(4).png"
        reverse
      />

      <FeatureSection
        title="Reward your team for generating more reviews"
        description="Motivate your team to proactively seek customer reviews by launching a well-structured incentive program. Boost participation by recognizing and rewarding top performers, fostering engagement and strengthening your brand’s reputation."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fa4b754e0bcefc2c9c0777_Group%201000005198%20(3).png"
      />

      <FeatureSection
        title="
        Reward your team for generating more reviews"
        description="Motivate your team to proactively seek customer reviews by launching a well-structured incentive program. Boost participation by recognizing and rewarding top performers, fostering engagement and strengthening your brand’s reputation."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f788a64cef28ad344f3d95_Frame%202085664989.png"
        reverse
      />

      <FeatureSection
        title="Incentivize reviews through leaderboards"
        description="Use leaderboards to drive engagement by tapping into the power of friendly competition, motivating customers to leave more reviews and increase overall participation"
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f78940f47f978c99495f96_Frame%202085664987%20(1).png"
      />

    </div>
  );
}

export default RestaurantFeatures;
